// EventRecorder implementation - pure event log storage
import type { SortEvent, EventRecorder } from './types';

export class EventRecorderImpl implements EventRecorder {
  events: SortEvent[] = [];

  reset(): void {
    this.events = [];
  }

  record(event: SortEvent): void {
    this.events.push(event);
  }

  replay(start?: number, end?: number): SortEvent[] {
    const from = start ?? 0;
    const to = end ?? this.events.length;
    return this.events.slice(from, to);
  }
}
